import { Tab } from '@mui/material';
import { useState } from 'react';

import { CustomTabPanel } from '@/erp/sale';
import { a11yProps } from '@/shared';
import {
  FormTabsOnly,
  SingleBoxTableTabsOnly,
  SingleTableBoxScene,
} from '@/shared/components/ui';
import AprobarFotosOTActualizadasActivacionPage from './AprobarFotosOTActualizadasActivacionPage';
import FotosEntradaReviewActivacion from './FotosEntradaReviewActivacion';
import FotosOTCargadaByTech from './FotosOTCargadaByTech';
import FotosSalidaReviewActivacion from './FotosSalidaReviewActivacion';
import FotosOTActivacionGestionada from './FotosOTActivacionGestionada';

export type FotosInstallActivacionITMainPageProps = {};

const FotosInstallActivacionITMainPage: React.FC<
  FotosInstallActivacionITMainPageProps
> = () => {
  const [valueTab, setValueTab] = useState(1);
  const handleMethodChange = (_event: any, newValue: number) => {
    setValueTab(newValue);
    // queryClient.invalidateQueries({
    //   queryKey: ["orden-trabajos", "es_entrada", "es_salida"],
    // });
  };

  return (
    <SingleTableBoxScene title={'Fotos de Instalación'}>
      <SingleBoxTableTabsOnly>
        <FormTabsOnly onChange={handleMethodChange} value={valueTab}>
          <Tab label={'Fotos Ingreso'} value={1} {...a11yProps(1)} />
          <Tab label={'Fotos Salida'} value={2} {...a11yProps(2)} />
          <Tab label={'Fotos Activación Gestionada'} value={3} {...a11yProps(3)} />

          <Tab
            label={'Actualización de Fotos Solicitada'}
            value={4}
            {...a11yProps(4)}
          />
          <Tab label={'Fotos Actualizadas'} value={5} {...a11yProps(5)} />
        </FormTabsOnly>
      </SingleBoxTableTabsOnly>

      {/* ============ Fotos Ingreso ============ */}
      <CustomTabPanel value={valueTab} index={1}>
        <FotosEntradaReviewActivacion />
      </CustomTabPanel>

      {/* ============ Fotos Salida ============ */}
      <CustomTabPanel value={valueTab} index={2}>
        <FotosSalidaReviewActivacion />
      </CustomTabPanel>

      {/* ============ Fotos Gestionadas ============ */}
      <CustomTabPanel value={valueTab} index={3}>
        <FotosOTActivacionGestionada />
      </CustomTabPanel>

      {/* ============ Solicitar actualización de fotos ============ */}
      <CustomTabPanel value={valueTab} index={4}>
        <FotosOTCargadaByTech />
      </CustomTabPanel>

      <CustomTabPanel value={valueTab} index={5}>
        <AprobarFotosOTActualizadasActivacionPage />
      </CustomTabPanel>
    </SingleTableBoxScene>
  );
};

export default FotosInstallActivacionITMainPage;
